module.exports = {
  OLD: { api: 'OLD', olderThan: 30, human: 'Oldtimer' },
  YT: { api: 'YT', olderThan: 20, human: 'Youngtimer' },
  NT: { api: 'NT', olderThan: 10, human: 'Newtimer' },
  PC: { api: 'PC', olderThan: 0, human: 'PremiumCars' }
}
